// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__pV9vt","savePackageButton":"ClientWallet_savePackageButton__3RhSJ"};